/**
 * Pool health card - shows collective pool performance
 */
export default function PoolCard({ data }) {
  // Handle undefined data with defaults
  const defaultData = {
    pool: { totalMembers: 10000, totalPremiums: 12000000, totalClaims: 10000000, lossRatio: 83.3, healthStatus: 'healthy' }
  };
  const safeData = data || defaultData;
  const { pool } = safeData;
  
  const healthConfig = {
    healthy: {
      color: '#4caf50',
      bg: 'bg-green-900/20',
      border: 'border-green-900/50',
      text: 'HEALTHY',
      description: 'Pool is profitable. Premiums exceed claims.'
    },
    warning: {
      color: '#ff9800',
      bg: 'bg-orange-900/20',
      border: 'border-orange-900/50',
      text: 'WARNING',
      description: 'Loss ratio high. Rate increase likely needed.'
    },
    critical: {
      color: '#f44336',
      bg: 'bg-red-900/20',
      border: 'border-red-900/50',
      text: 'CRITICAL',
      description: 'Pool losing money. Rate increase required.'
    }
  };

  const health = healthConfig[pool.healthStatus];
  const isLosing = pool.totalClaims > pool.totalPremiums;
  const deficit = pool.totalClaims - pool.totalPremiums;

  return (
    <div className={`bg-[#1a1a1a] border-2 rounded-xl p-6 shadow-[0_5px_20px_rgba(0,0,0,0.5)]`} style={{ borderColor: health.color }}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-2xl font-bold" style={{ color: health.color }}>THE POOL</h3>
        <div className={`px-3 py-1 rounded-full border text-xs font-bold ${health.bg} ${health.border}`} style={{ color: health.color }}>
          {health.text}
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex justify-between text-sm">
          <span className="text-[#888]">Total Members</span>
          <span className="text-white font-mono font-bold">{pool.totalMembers.toLocaleString()}</span>
        </div>
        
        <div className="flex justify-between text-sm">
          <span className="text-[#888]">Premiums Collected</span>
          <span className="text-[#4caf50] font-mono font-bold">
            ${(pool.totalPremiums / 1000000).toFixed(1)}M
          </span>
        </div>
        
        <div className="flex justify-between text-sm">
          <span className="text-[#888]">Claims Paid</span>
          <span className="text-[#f44336] font-mono font-bold">
            ${(pool.totalClaims / 1000000).toFixed(1)}M
          </span>
        </div>

        <div className="pt-3 border-t border-[#333]">
          <div className="flex justify-between items-baseline mb-2">
            <span className="text-[#888] text-sm">Loss Ratio</span>
            <span className="text-2xl font-mono font-bold" style={{ color: health.color }}>
              {pool.lossRatio.toFixed(1)}%
            </span>
          </div>
          <div className="text-xs text-[#666]">
            Target: 85% | Break-even: 100%
          </div>
        </div>

        {isLosing && (
          <div className={`${health.bg} ${health.border} border rounded-lg p-3`}>
            <div className="text-xs font-semibold uppercase mb-1" style={{ color: health.color }}>
              💸 Pool Losing Money
            </div>
            <div className="text-xs text-[#ccc]">
              Deficit: ${(deficit / 1000000).toFixed(1)}M
            </div>
          </div>
        )}

        <div className={`${health.bg} ${health.border} border rounded-lg p-3`}>
          <div className="text-xs text-[#ccc] leading-relaxed">
            {health.description}
          </div>
        </div>
      </div>
    </div>
  );
}


